// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".discord-dialog .close-icon{cursor:pointer;position:absolute!important;right:12px;top:12px}.discord-dialog .discord-title{word-break:normal}.discord-dialog .connect-button,.discord-dialog .connect-button a,.discord-dialog .connect-button button{width:100%}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
